module.exports = __webpack_public_path__ + "static/media/instagram.f2758fcc.svg";